import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DeviceDetectorService } from 'ngx-device-detector';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { fetchUserAction, setAuthModal } from '@state/auth/auth.actions';
import { selectAuthToken, selectAuthUser } from '@state/auth/auth.selectors';

import { syncPropertyReferrals } from '@core/utils/referrals';
import {
  ACCOUNT_SETUP_MIN_DATE,
  REVIEW_CBSA_PREFERENCES_MIN_DATE,
} from '@core/constants/auth';
import { PropertiesService } from '@core/services/properties.service';

@UntilDestroy()
@Component({
  selector: 'app-full-layout',
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss'],
})
export class FullLayoutComponent implements OnInit {
  protected token: string | undefined = undefined;
  protected isMobile = false;

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private deviceService: DeviceDetectorService,
    private propertiesService: PropertiesService
  ) {}

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobile();
    this.store
      .select(selectAuthToken)
      .pipe(untilDestroyed(this))
      .subscribe((token) => {
        if (token && token !== this.token) this.fetchUser();
        this.token = token;
      });
  }

  fetchUser(): void {
    this.store.dispatch(fetchUserAction());
    this.store
      .select(selectAuthUser)
      .pipe(untilDestroyed(this))
      .subscribe((user) => {
        if (user) {
          if (user.isActive === false) {
            this.router.navigate(['/auth', 'deactivated']);
            return;
          }
          if (!user.phoneNumber) {
            this.store.dispatch(
              setAuthModal({ authModal: 'add-phone-number' })
            );
            return;
          }
          if (
            user.emailConfirmedAt === null ||
            user.phoneNumberConfirmedAt === null
          ) {
            this.store.dispatch(setAuthModal({ authModal: 'verify-identity' }));
            return;
          }
          if (
            (!user.preference || !user.preference.roles) &&
            new Date(user.insertedAt) >= ACCOUNT_SETUP_MIN_DATE
          ) {
            this.store.dispatch(setAuthModal({ authModal: 'account-setup' }));
            return;
          }
          if (
            !user?.cbsaPreferences ||
            user.cbsaPreferences.length === 0 ||
            new Date(user.cbsaPreferences[0]?.updatedAt) <
              REVIEW_CBSA_PREFERENCES_MIN_DATE
          ) {
            this.store.dispatch(
              setAuthModal({ authModal: 'review-cbsa-preferences' })
            );
            return;
          }
          syncPropertyReferrals(this.store, this.propertiesService);
        }
      });
  }
}
